export enum ElementTypeDTO {
  STOP_NAME = 'STOP_NAME',
  STOP_DIRECTION_NAME = 'STOP_DIRECTION_NAME',
  TIME_COUNT_DOWN = 'TIME_COUNT_DOWN',
  CLOCK = 'CLOCK',
  TEXT_CONSTANT = 'TEXT_CONSTANT',
  DELAY = 'DELAY',
  TIME = 'TIME',
  PAGE_COUNTER = 'PAGE_COUNTER',
  TIME_SCHEDULED = 'TIME_SCHEDULED',
  IMAGE_DISPLAY_NORMAL = 'IMAGE_DISPLAY_NORMAL',
  PAGER = 'PAGER',
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  TIMETABLE = 'TIMETABLE',
}
